import { GlAvatar, GlAvatarLink, GlBadge, GlDisclosureDropdown, GlDisclosureDropdownItem, GlCollapsibleListbox, GlLink, GlButton, GlIcon, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__, sprintf } from '~/locale';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { cleanLeadingSeparator } from '~/lib/utils/url_utility';
import { formatDate } from '~/lib/utils/datetime_utility';
import AbuseCategorySelector from '/builds/gitlab/gitlab-ee/app/assets/javascripts/abuse_reports/components/abuse_category_selector.vue?vue3';
import Markdown from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/markdown/non_gfm_markdown.vue?vue3';
import TopicBadges from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/topic_badges.vue?vue3';
import { VERIFICATION_LEVEL_UNVERIFIED, VISIBILITY_LEVEL_PRIVATE } from '../../constants';
import CiVerificationBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/catalog/components/shared/ci_verification_badge.vue?vue3';
import ProjectVisibilityIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/catalog/components/shared/project_visibility_icon.vue?vue3';
import CiResourceHeaderSkeletonLoader from './ci_resource_header_skeleton_loader.vue';
export default {
    name: 'CiResourceHeader',
    i18n: {
        moreActionsLabel: __('More actions'),
        reportAbuse: __('Report abuse'),
        lastRelease: s__('CiCatalog|Released %{date}'),
        lastReleaseMissing: s__('CiCatalog|No release available')
    },
    components: {
        AbuseCategorySelector,
        CiResourceHeaderSkeletonLoader,
        CiVerificationBadge,
        GlAvatar,
        GlAvatarLink,
        GlBadge,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlCollapsibleListbox,
        GlLink,
        GlButton,
        GlIcon,
        Markdown,
        ProjectVisibilityIcon,
        TopicBadges
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: [
        'reportAbusePath'
    ],
    props: {
        isLoadingData: {
            type: Boolean,
            required: true
        },
        isSearchingVersions: {
            type: Boolean,
            required: false,
            default: false
        },
        resource: {
            type: Object,
            required: true
        },
        versions: {
            type: Array,
            required: true
        },
        initialVersionId: {
            type: String,
            required: false,
            default: null
        },
        latestVersionName: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'version-selected',
        'version-search'
    ],
    data () {
        return {
            isReportAbuseDrawerOpen: false,
            selectedVersion: {}
        };
    },
    computed: {
        authorId () {
            return this.hasVersion && this.currentVersion?.author?.state === 'active' ? getIdFromGraphQLId(this.currentVersion?.author?.id) : 0;
        },
        entityId () {
            return getIdFromGraphQLId(this.resource.id);
        },
        hasVersion () {
            return this.currentVersion?.name;
        },
        hasTopics () {
            return this.resource?.topics?.length;
        },
        isProjectPrivate () {
            return this.resource?.visibilityLevel === VISIBILITY_LEVEL_PRIVATE;
        },
        isVerified () {
            return this.resource?.verificationLevel !== VERIFICATION_LEVEL_UNVERIFIED;
        },
        lastReleaseText () {
            if (this.currentVersion?.releasedAt) {
                const date = formatDate(this.currentVersion.releasedAt);
                return sprintf(this.$options.i18n.lastRelease, {
                    date
                });
            }
            return this.$options.i18n.lastReleaseMissing;
        },
        currentVersion () {
            return this.resource?.versions?.nodes[0] || {};
        },
        reportedFromUrl () {
            return window.location.href;
        },
        versionBadgeText () {
            return this.currentVersion.name;
        },
        webPath () {
            return cleanLeadingSeparator(this.resource?.webPath);
        },
        isArchived () {
            return Boolean(this.resource.archived);
        },
        isLatestVersion () {
            return this.currentVersion.name === this.latestVersionName;
        },
        versionBadgeVariant () {
            return this.isLatestVersion ? 'info' : 'neutral';
        },
        selectedVersionValue () {
            return this.selectedVersion.value ?? null;
        },
        toggleButtonText () {
            if (this.selectedVersion.text) {
                return this.selectedVersion.text;
            }
            if (this.isLoadingData) {
                return __('Loading');
            }
            return s__('CiCatalog|No versions available');
        }
    },
    watch: {
        // `initialVersionId` is null until the parent's versions query resolves, so the
        // selection cannot be seeded in `data()`. The lookup needs `versions` to be
        // populated in the same flush, which is how the parent assigns both.
        initialVersionId: {
            immediate: true,
            handler (versionId) {
                if (versionId) {
                    this.selectedVersion = this.getSelectedVersion(versionId);
                }
            }
        }
    },
    methods: {
        onAbuseButtonClicked () {
            this.toggleReportAbuseDrawer(true);
        },
        toggleReportAbuseDrawer (isOpen) {
            this.isReportAbuseDrawerOpen = isOpen;
        },
        getSelectedVersion (versionId) {
            return this.versions.find((v)=>v.value === versionId) || {};
        },
        onVersionSelect (versionId) {
            this.selectedVersion = this.getSelectedVersion(versionId);
            if (this.selectedVersion.text) {
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        version: this.selectedVersion.text
                    }
                });
                this.$emit('version-selected', this.selectedVersion.text);
            }
        },
        onVersionSearch (searchTerm) {
            this.$emit('version-search', searchTerm);
        }
    }
};
